import { create } from 'zustand';

/**
 * Stan otwarcia omniboksa — **efemeryczny UI**, więc Zustand, a nie URL ani serwer
 * (spec 12A: trzy tiery stanu).
 *
 * Store, a nie stan lokalny powłoki, z jednego konkretnego powodu: spec sek. 5 wymaga
 * **skrótu „dodaj zadanie do bieżącego elementu"**, który otwiera omnibox w trybie `!`
 * z wstawionym elementem. Otwierać go musi więc ekran elementu, a nie tylko powłoka —
 * przekazywanie tego propsami przez całe drzewo byłoby gorsze.
 */
interface OmniboxState {
  isOpen: boolean;
  /** Tekst, od którego pole ma wystartować — pozwala otworzyć je w gotowym trybie. */
  initialInput: string;
  open: (initialInput?: string) => void;
  close: () => void;
}

export const useOmniboxStore = create<OmniboxState>((set) => ({
  isOpen: false,
  initialInput: '',
  open: (initialInput = '') => set({ isOpen: true, initialInput }),
  close: () => set({ isOpen: false, initialInput: '' }),
}));
